





































# import settings from '@/settings'
import q from '@/graphql/query'
import n from '@/utils/notifications'

export default {
    name: 'users_interviews_coming'

    data: ()->
        alert: false
        loading: true
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        interviews_coming: []
        next_interview: {
            interview_type: {
                label: ''
            }
            datetime_str: ''
            with_who: ''
        }

    computed:
        data_filtered: ()->
            self = @
            data = @interviews_coming.filter (x) ->
                !self.search || x.with_who.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.with_who.toLowerCase().includes(self.search.toLowerCase())\
                || interview_type.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || interview_type.label.toLowerCase().includes(self.search.toLowerCase())\
                || x.datetime_str.includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

    methods:
        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @interviews_coming.sort (a,b)->
                modifier = 1
                field_a = a[prop]
                field_b = b[prop]
                if prop == 'interview_type.label'
                    props = prop.split('.')
                    field_a = a[props[0]][props[1]]
                    field_b = b[props[0]][props[1]]
                else if prop == 'datetime_str'
                    field_a = a['datetime']
                    field_b = b['datetime']
                if order == 'descending'
                    modifier = -1
                return field_a.toLowerCase().localeCompare(field_b.toLowerCase())*modifier
            # console.log "INTERVIEWS SORT ", @interviews

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        get_interviews_coming: ()->
            self = @
            @loading = true
            q.run('get_interview_coming_set', [])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_interviews_coming: get_interviews_coming: then", e.message)
                else
                    # console.log "GET interviews coming : ", resp.body.data.interview_coming_set
                    self.interviews_coming = resp.body.data.interview_coming_set
                    self.next_interview = self.interviews_coming[0]
                    self.loading = false
                    if self.interviews_coming.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "users_interviews_coming: get_interviews_coming()")
            
    beforeMount: ()->
        @get_interviews_coming()
}
